import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InventoryService } from '../inventory.service';
import { Product } from '../../products/products.model';
import { LocationDto, TransferInventoryDto } from '../inventory.model';

@Component({
  selector: 'app-transfer-inventory',
  templateUrl: './transfer-inventory.component.html',
  styleUrl: './transfer-inventory.component.scss',
  standalone: true,
  imports:[FormsModule,ReactiveFormsModule]
})
export class TransferInventoryComponent implements OnInit {
  private fb = inject(FormBuilder);
  private inventoryService = inject(InventoryService);

  transferForm!: FormGroup;
  allLocations: LocationDto[] = [];
  targetLocations: LocationDto[] = [];
  availableProducts: Product[] = [];

  ngOnInit(): void {
    this.transferForm = this.fb.group({
      sourceLocationId: ['', Validators.required],
      productId: ['', Validators.required],
      targetLocationId: ['', Validators.required],
      quantity: [null, [Validators.required, Validators.min(1)]],
      remarks: [''],
    });

    this.loadLocations();

    this.transferForm.get('sourceLocationId')?.valueChanges.subscribe((sourceId) => {
      this.transferForm.get('productId')?.reset();
      this.availableProducts = [];

      if (sourceId) {
        this.inventoryService.getInventoryByLocation(sourceId).subscribe((res: any[]) => {
          this.availableProducts = res
            .filter(i => i.quantity > 0 && i.product?.isActive)
            .map(i => i.product!)
            .filter(p => p !== undefined);
        });

        this.targetLocations = this.allLocations.filter(l => l.id !== sourceId);
      } else {
        this.targetLocations = [...this.allLocations];
      }

      this.transferForm.get('targetLocationId')?.reset();
    });
  }

  loadLocations() {
    this.inventoryService.getAllLocations().subscribe(res => {
      this.allLocations = res || [];
      this.targetLocations = [...this.allLocations];
    });
  }

  submitTransfer() {
    if (this.transferForm.invalid) return;

    const dto: TransferInventoryDto = this.transferForm.value;
    this.inventoryService.transferStock(dto).subscribe({
      next: () => {
        alert('Stock transferred successfully');
        this.transferForm.reset();
        this.availableProducts = [];
      },
      error: () => {
        alert('Transfer failed. Please check quantity or other details.');
      }
    });
  }
}
